export default "__VITE_ASSET__CwZXVw72__"